import { create } from 'zustand'
import usePreferencesStore from './preferencesStore'

const useAppStore = create((set) => ({
  sidebarCollapsed: usePreferencesStore.getState().sidebarCollapsed,
  toggleSidebar: () =>
    set((state) => {
      const next = !state.sidebarCollapsed
      usePreferencesStore.getState().setSidebarCollapsed(next)
      return { sidebarCollapsed: next }
    }),

  user: null,
  setUser: (user) => set({ user }),

  // Navigation state (populated from /objecttypes API)
  objectTypes: null, // null = not loaded yet, [] = loaded but empty
  setObjectTypes: (objectTypes) => set({ objectTypes }),
}))

export default useAppStore
